<div class="col-12 relative full-height overflow-hidden flex flex-column">
  <ng-content></ng-content>
</div>
